import {
    apiRequest,
    pensiunSubmit,
    pensiunDetail,
    masterEmployee,
    loadEmployee
} from "../../../../../services/adapters/kepegawaian/pensiunService"

class SubmitRepository {

    fetchSubmit = async (query) => {
        return await apiRequest("post", pensiunSubmit, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", pensiunDetail, {
            params: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", masterEmployee, {
            params: query
        }, true)
    }

    fetchDetailEmployee = async (query) => {
        return await apiRequest("get", loadEmployee, {
            params: query
        }, true)
    }
    
}

export default SubmitRepository